import React, { Component } from "react";
import { Parse } from "parse";
import { connect } from "react-redux";
import moment from "moment";
import styled from "styled-components";
import { Button, Icon, Card, Row, Col } from "antd";

const Informations = styled.p`
  color: #0000FE;
  text-align: center;
  font-size: 18px;
`;

class ProfilPro extends Component {
  abo() {
    return (
      <Informations>
        <Icon type="profile" /> Abonnement
      </Informations>
    );
  }

  job() {
    return (
      <Informations>
        <Icon type="user" /> Professionnel
      </Informations>
    );
  }

  remu() {
    return (
      <Informations>
        <Icon type="area-chart" /> Rémunération
      </Informations>
    );
  }

  lieu() {
    return (
      <Informations>
        <Icon type="home" /> Lieux
      </Informations>
    );
  }

  finAbo() {
    let attributes = Parse.User.current().attributes;
    let now = moment();
    if (!attributes.expirationAbo) {
      return "Tu n'as pas de contrat en cours, rends-toi sur la page Achat.";
    }
    if (now._d < moment(attributes.expirationAbo)) {
      return `J - ${moment(attributes.expirationAbo).diff(moment(), "days")}`;
    } else {
      //  console.log(moment(attributes.expirationAbo).format('MMMM Do YYYY'))
      return `Ton contrat a expiré depuis le ${moment(
        attributes.expirationAbo
      ).format("Do MMMM YYYY")}. `;
    }
  }

  renouveler() {
    return (
      <Informations>
        <Icon type="hourglass" /> Fin du contrat{" "}
      </Informations>
    );
  }

  getRemu() {
    if (!Parse.User.current().attributes.stripeId) {
      return (
        <a href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_E9XJDgbPwntmWHYx8ZkKMgkciosTPhAx&scope=read_write">
          <Button> Connecter mon compte Stripe </Button>{" "}
        </a>
      );
    } else {
      if (Parse.User.current().attributes.remuneration) {
        return `${Parse.User.current().attributes.remuneration} €`;
      } else return `0 €`;
    }
  }

  chooseStyle() {
    let user = Parse.User.current();
    if (user.attributes.programme) {
      if (user.attributes.programme.length === 2) {
        return (
          <Card
            title={this.abo()}
            bordered={false}
            style={{ textAlign: "center" }}
          >
            <p>{user.attributes.programme[0]}</p>
            <p>{user.attributes.programme[1]}</p>
          </Card>
        );
      }
      return (
        <Card
          title={this.abo()}
          bordered={false}
          style={{ textAlign: "center" }}
        >
          {user.attributes.programme[0]}
        </Card>
      );
    } else
      return (
        <Card
          title={this.abo()}
          bordered={false}
          style={{ textAlign: "center" }}
        >
          Pas de programme sélectionné
        </Card>
      );
  }

  render() {
    let attributes = Parse.User.current().attributes;
    return (
      <div>
        <div style={{ padding: "30px" }}>
          <Row gutter={16}>
            <Col span={8}>{this.chooseStyle()}</Col>
            <Col span={8}>
              <Card
                title={this.job()}
                bordered={false}
                style={{ textAlign: "center" }}
              >
                {attributes.job}
              </Card>
            </Col>
            <Col span={8}>
              <Card
                title={this.remu()}
                bordered={false}
                style={{ textAlign: "center" }}
              >
                {this.getRemu()}
              </Card>
            </Col>
          </Row>
        </div>
        <div style={{ padding: "30px" }}>
          <Row gutter={16}>
            <Col span={8}>
              <Card
                title={this.lieu()}
                bordered={false}
                style={{ textAlign: "center" }}
              >
                Urban Fitness Rouen
              </Card>
            </Col>
            <Col span={8}>
              <Card
                title={this.renouveler()}
                bordered={false}
                style={{ textAlign: "center" }}
              >
                {this.finAbo()}
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedProfilPro = connect(
  mapStateToProps,
  null
)(ProfilPro);
export default connectedProfilPro;
